import axios from 'axios';

// ----------------------------------------------------------------------

const axiosInstance = axios.create();
axiosInstance.defaults.baseURL = process.env.REACT_APP_CUSTOMIZATION_DOMAIN;
// axiosInstance.defaults.baseURL = "http://localhost:7000";
axiosInstance.interceptors.response.use(
  (response) => response,
  (error) =>
    {
      // console.log("Error: " + error.response.data.message);
      return Promise.reject(
        (error.response && error.response.data) || 'Something went wrong'
      )
    }
);

export default axiosInstance;
